import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { truncateText, visuallyHidden } from './../../core';

const StyledButtonText = styled.span.withConfig({
  shouldForwardProp: (prop) => !['isHidden'].includes(prop),
})`
  ${truncateText}
  color: inherit;
  display: inline-block;
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndex.buttonContent.value};

  ${({ isHidden }) =>
    isHidden &&
    css`
      ${visuallyHidden}

      && {
        position: absolute;
      }
    `}
`;

const ButtonText = (props) => <StyledButtonText {...props} />;

ButtonText.propTypes = {
  /** If true, visually hides text */
  isHidden: PropTypes.bool,
};

ButtonText.defaultProps = {
  isHidden: false,
};

export { ButtonText };
